import { Link } from 'react-router-dom';

const WHATSAPP_URL = 'https://wa.me/923179699957?text=Hi%20Moin%20Khan%20Boxing%20Academy!%20I%20want%20to%20join%20training';
const PHONE_NUMBER = '0317-9699957';

const quickLinks = [
  { label: 'Home', path: '/' },
  { label: 'Programs', path: '/programs' },
  { label: 'Trainers', path: '/trainers' },
  { label: 'About', path: '/about' },
  { label: 'Gallery', path: '/gallery' },
  { label: 'Contact', path: '/contact' },
];

const programLinks = [
  { label: 'Private Training', path: '/programs' },
  { label: 'Group Training', path: '/programs' },
  { label: 'Youth Program', path: '/programs' },
  { label: 'Home Training', path: '/programs' },
];

export default function Footer() {
  return (
    <footer className="bg-black border-t-2 border-boxing-red">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/a84fce21c15147349888dd3eeb9b8000/7c39edfd8d694e22a7ddecad8773ce48.png"
                alt="Moin Khan Boxing Academy"
                className="h-12 w-12 object-contain"
              />
              <div>
                <span className="font-bebas text-xl tracking-wider text-white leading-none block">
                  MOIN KHAN
                </span>
                <span className="font-oswald text-[10px] uppercase tracking-[3px] text-white/50 leading-none block mt-0.5">
                  Boxing Academy
                </span>
              </div>
            </div>
            <p className="text-boxing-textgray text-sm leading-relaxed mb-4">
              Elite boxing training for all levels. Build strength, discipline, and confidence with an international boxer.
            </p>
            <a
              href={`tel:+92${PHONE_NUMBER.replace(/-/g, '')}`}
              className="flex items-center gap-2 text-white/70 text-sm hover:text-boxing-red transition-colors duration-300 mb-2"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-sm" />
              </span>
              {PHONE_NUMBER}
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-white/70 text-sm hover:text-boxing-red transition-colors duration-300"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-whatsapp-line text-sm" />
              </span>
              {PHONE_NUMBER}
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-oswald uppercase text-sm tracking-[2px] text-white mb-5">
              Quick Links
            </h4>
            <ul className="flex flex-col gap-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-boxing-textgray text-sm hover:text-boxing-red transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h4 className="font-oswald uppercase text-sm tracking-[2px] text-white mb-5">
              Programs
            </h4>
            <ul className="flex flex-col gap-3">
              {programLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-boxing-textgray text-sm hover:text-boxing-red transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h4 className="font-oswald uppercase text-sm tracking-[2px] text-white mb-3">
              Start Your Journey
            </h4>
            <p className="text-boxing-textgray text-sm leading-relaxed mb-5">
              Ready to train? Get in touch and start your boxing journey today.
            </p>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary w-full"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-whatsapp-line text-base" />
              </span>
              Join Now via WhatsApp
            </a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-boxing-textgray text-xs text-center sm:text-left">
            {new Date().getFullYear()} Moin Khan Boxing Academy. All rights reserved.
          </p>
          <p className="text-boxing-textgray text-xs">
            Train with an international boxer
          </p>
        </div>
      </div>
    </footer>
  );
}